import { render, staticRenderFns } from "./MessageTemplateCategory.vue?vue&type=template&id=5030870b&scoped=true"
import script from "./MessageTemplateCategory.vue?vue&type=script&lang=js"
export * from "./MessageTemplateCategory.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateCategory.vue?vue&type=style&index=0&id=5030870b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030870b",
  null
  
)

export default component.exports